var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sa-loader-bg"},[_c('img',{staticClass:"sa-loader-img",attrs:{"src":"https://img.litedev.com/images/loader.svg","width":"36","height":"36","alt":"loader"}})])
}]

export { render, staticRenderFns }